import { useState } from "react";
import AccordionHighlights from "./index";
import { AccordionData } from "./data";
import * as StyledAccordion from "./Styled.Accordion";

const AccordionHighlightsContainer = ({
  data = AccordionData,
  initialExpanded = 0,
}) => {
  const [expanded, setExpanded] = useState(initialExpanded);

  return (
    <StyledAccordion.HighlightsWrapper>
      {data.map((item, index) => (
        <AccordionHighlights
          key={item.id || index}
          id={index}
          title={item.title}
          label={item.label}
          cta={item.cta}
          link={item.link}
          content={item.content}
          expanded={expanded}
          setExpanded={setExpanded}
        />
      ))}
    </StyledAccordion.HighlightsWrapper>
  );
};

export default AccordionHighlightsContainer;
